import React, { useState, useEffect } from 'react';
import { validateCredentials, saveLoginState } from '../utils/auth';
import { logAuthDebug } from '../utils/authDebug';

const Login = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Debug: Log authentication configuration on mount
  useEffect(() => {
    logAuthDebug();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    // Validate credentials
    if (validateCredentials(email, password)) {
      saveLoginState();
      setTimeout(() => {
        setIsLoading(false);
        onLoginSuccess();
      }, 300);
    } else {
      setTimeout(() => {
        setError('Invalid email or password');
        setIsLoading(false);
      }, 300);
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-purple-50 to-indigo-50 px-4 py-8">
      <div className="w-full max-w-md">
        {/* Login Card */}
        <div className="bg-white rounded-2xl shadow-xl p-8 sm:p-10">
          {/* Logo/Title */}
          <div className="text-center mb-8">
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-2">
              Login
            </h1>
            <p className="text-sm text-gray-500">
              Enter your credentials to continue
            </p>
          </div>

          {/* Login Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Email Field */}
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700 mb-2"
              >
                Email address
              </label>
              <input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter email"
                className="w-full px-4 py-3 rounded-lg border border-gray-300
                         text-gray-800 placeholder-gray-400
                         focus:outline-none focus:ring-2 focus:ring-[#583ca3] focus:border-transparent
                         transition-all duration-200
                         disabled:bg-gray-100 disabled:cursor-not-allowed"
                disabled={isLoading}
              />
            </div>

            {/* Password Field */}
            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-700 mb-2"
              >
                Password
              </label>
              <input
                id="password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                className="w-full px-4 py-3 rounded-lg border border-gray-300
                         text-gray-800 placeholder-gray-400
                         focus:outline-none focus:ring-2 focus:ring-[#583ca3] focus:border-transparent
                         transition-all duration-200
                         disabled:bg-gray-100 disabled:cursor-not-allowed"
                disabled={isLoading}
              />
            </div>

            {/* Error Message */}
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg text-sm">
                {error}
              </div>
            )}

            {/* Login Button */}
            <button
              type="submit"
              disabled={isLoading}
              className={`w-full py-3 px-4 rounded-lg
                       bg-[#583ca3] hover:bg-[#5B21B6]
                       text-white font-semibold text-base
                       transition-all duration-200
                       focus:outline-none focus:ring-2 focus:ring-[#583ca3] focus:ring-offset-2
                       disabled:opacity-50 disabled:cursor-progress
                       active:scale-[0.98]
                       shadow-md hover:shadow-lg
                       cursor-pointer
                       `}
            >
              {isLoading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        </div>

        {/* Footer */}
        <div className="text-center mt-6">
          <p className="text-xs text-gray-500">
            Addiwise Prosthetic Design Platform
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
